import type {
  HeadlineModuleProps,
  HeroProductSectionHeadlineProps as HeadlineProps
} from '@hypercodestudio/basler-components';

import type {
  IHeroArticleSection,
  IHeroOverviewSection,
  IHeroProductSection
} from '~~/lib/ContentfulService';
import { mapHeadline } from '~/utils/mapHeadline';
import { isDefined } from '~/utils/guards/isDefined';
import { isEntryResolveError } from '~/utils/guards/isEntryResolveError';

export function mapHeroSubtitle(
  heroItem: IHeroArticleSection | IHeroOverviewSection | IHeroProductSection,
  centeredText?: boolean
): (HeadlineProps & HeadlineModuleProps) | undefined {
  if (
    isDefined(heroItem.fields.advancedSubtitle) &&
    !isEntryResolveError(heroItem.fields.advancedSubtitle)
  ) {
    const mappedSubtitle = mapHeadline(heroItem.fields.advancedSubtitle);

    return centeredText !== undefined
      ? { ...mappedSubtitle, isCentered: centeredText }
      : mappedSubtitle;
  }

  if (heroItem.fields.subtitle) {
    return {
      content: heroItem.fields.subtitle,
      ...(centeredText !== undefined ? { isCentered: centeredText } : {}),
      level: 2
    };
  }
}
